class ScentSelectorComponent extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.priceInput = null;
    this.scentOptions = [];
    this.currentScentPrice = 0;
    this.blockSettings = {};
  }

  connectedCallback() {
    try {
      this.blockSettings = JSON.parse(this.getAttribute('data-block-settings') || '{}');
    } catch (e) {
      this.blockSettings = {};
    }

    // Get collapsible setting
    this.enableCollapsible = this.getAttribute('data-enable-collapsible') === 'true';

    // Initialize collapse functionality if enabled
    if (this.enableCollapsible) {
      this.initializeCollapse();
    }

    this.form = document.forms[this.getAttribute('data-product-form-id')];
    this.scentSelectionInput = this.querySelector('[data-scent-selection-input]');
    this.priceDisplay = this.querySelector('[data-scent-price-display]');
    this.scentOptions = Array.from(this.querySelectorAll('[data-scent-option] input[type="radio"]'));

    this.bindEvents();
    this.updateScentSelection();
  }

  initializeCollapse() {
    this.header = this.querySelector('.scent-selector-collapsible__header');
    this.content = this.querySelector('.scent-selector-collapsible__content');

    if (!this.header || !this.content) return;

    // Add click handler for header
    this.header.addEventListener('click', () => this.toggleCollapse());

    // Add keyboard support
    this.header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggleCollapse();
      }
    });

    // Start collapsed by default
    this.isExpanded = false;
  }

  toggleCollapse() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.classList.add('is-expanded');
      this.header.setAttribute('aria-expanded', 'true');
    } else {
      this.classList.remove('is-expanded');
      this.header.setAttribute('aria-expanded', 'false');
    }
  }

  bindEvents() {
    this.scentOptions.forEach((option) => {
      option.addEventListener('change', () => this.updateScentSelection());
    });

    if (this.form) {
      this.form.addEventListener('variant:change', () => {
        this.updateScentSelection();
      });
    }
  }

  updateScentSelection() {
    const selectedOption = this.querySelector('input[type="radio"]:checked');
    if (selectedOption) {
      const scentValue = selectedOption.dataset.scentValue || selectedOption.value;
      const price = parseInt(selectedOption.dataset.scentPrice) || 0;
      this.currentScentPrice = price;

      if (this.scentSelectionInput) {
        if (scentValue === 'None') {
          this.scentSelectionInput.value = '';
          this.scentSelectionInput.removeAttribute('name');
        } else {
          this.scentSelectionInput.value = scentValue;
          this.scentSelectionInput.setAttribute('name', 'properties[Scent Selection]');
        }
      }

      if (this.priceDisplay) {
        // if (price > 0) {
        //   this.priceDisplay.innerHTML = `
        //     <span class="discounted-price">Complimentary</span>
        //     <span class="original-price">${this.formatPrice(price)}</span>
        //   `;

        //   const originalPrice = this.priceDisplay.querySelector('.original-price');
        //   if (originalPrice) {
        //     originalPrice.style.textDecoration = 'line-through';
        //     originalPrice.style.marginLeft = '0.5em';
        //     originalPrice.style.color = 'var(--color-text-muted, #767676)';
        //   }
        // } else {
        //   this.priceDisplay.textContent = 'Complimentary';
        // }
        this.priceDisplay.textContent = 'Complimentary';
      }

      const event = new CustomEvent('scent:changed', {
        bubbles: true,
        detail: {
          scent: scentValue,
          price: price,
          formattedPrice: this.formatPrice(price),
        },
      });
      this.dispatchEvent(event);

      this.updatePriceDisplays(price);
    }
  }

  formatPrice(cents) {
    if (cents === 0) return 'Complimentry';

    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    // Fallback to Intl.NumberFormat
    return new Intl.NumberFormat(window.Shopify?.locale || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(cents / 100);
  }

  updatePriceDisplays(scentPrice) {
    // Update any existing price displays to include scent price
    const priceElements = document.querySelectorAll('[data-price-display]');
    priceElements.forEach((element) => {
      const basePrice = parseInt(element.dataset.basePrice) || 0;
      const totalPrice = basePrice + scentPrice;
      element.textContent = this.formatPrice(totalPrice);
    });
  }

  getScentPrice() {
    return this.currentScentPrice;
  }

  getSelectedScent() {
    const selectedOption = this.querySelector('input[type="radio"]:checked');
    return selectedOption ? selectedOption.value : null;
  }

  getSelectedScentData() {
    const selectedOption = this.querySelector('input[type="radio"]:checked');
    if (!selectedOption) return null;

    return {
      name: selectedOption.value,
      price: parseInt(selectedOption.dataset.scentPrice) || 0,
      formattedPrice: this.formatPrice(parseInt(selectedOption.dataset.scentPrice) || 0)
    };
  }
}

// Register the custom element
if (!customElements.get('scent-selector-component')) {
  customElements.define('scent-selector-component', ScentSelectorComponent);
}

// Export for potential use in other scripts
window.ScentSelectorComponent = ScentSelectorComponent;
